import { render, staticRenderFns } from "./personalDataPoliticsModal.vue?vue&type=template&id=782c7980"
import script from "./personalDataPoliticsModal.vue?vue&type=script&lang=js"
export * from "./personalDataPoliticsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports